import { ref } from "vue";

export const selectValue = ref(-1)